import { InjectionToken } from '@angular/core'

export const ENVIRONMENT = new InjectionToken<any>('ENVIRONMENT')
export const STORAGE_PREFIX = new InjectionToken<any>('STORAGE_PREFIX')
export const CURRENT_USER = new InjectionToken<any>('CURRENT_USER')
export const CURRENT_ACCOUNT_ID = new InjectionToken<any>('CURRENT_ACCOUNT_ID')
export const AUTH_TOKEN = new InjectionToken<any>('AUTH_TOKEN')
